import type { PaymentMethods } from "bonusx-api-main-manager";
import { atomWithStorage } from "jotai/utils";
import type { IProductWithCmsDataAndQualification } from "../pages/ProductsListPage/entities/product-with-cms-data-and-qualification/product-with-cms-data-and-qualification.entity.interface";

export type CartItem = {
  count: number;
  product: IProductWithCmsDataAndQualification;
  discountPrice: number;
  discountCode: string;
};

export type CartItems = Array<CartItem>;

export const CART_STORAGE_INDEX = "bx-cart";
export const PAYMENT_METHOD_STORAGE_INDEX = "bx-payment-methods";

/*
  Questo store è un frammento del "shoppingCartStore"
*/
export const CartAtom = atomWithStorage<CartItems>(CART_STORAGE_INDEX, []);

export const PaymentMethodStore = atomWithStorage<PaymentMethods | undefined>(
  PAYMENT_METHOD_STORAGE_INDEX,
  undefined,
  undefined,
  { getOnInit: true }
);
